// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"card__msignaturepad___3_Kv6","m-signature-pad--body":"card__m-signature-pad--body___2QnNG","m-signature-pad--footer":"card__m-signature-pad--footer___Or7D1","description":"card__description___1Qe-4","button":"card__button___2v8EX","clear":"card__clear___PR_xh","save":"card__save___vR0lx","m-signature-pad":"card__m-signature-pad___UhGx5","github":"card__github___pWwUg","cardTitle":"card__cardTitle___2iTkP","subtitle":"card__subtitle___3cxBa","large":"card__large___2F3JL","title":"card__title___1ImmB"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/styles/card.scss
// module id = gTrv
// module chunks = client